import { createRoot } from 'react-dom/client';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import React, { useEffect, useState} from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { getAllLeads, addLead } from '../../api/leads.api';
import { getAllEnumFromServer } from '../../api/enum.api';
import { Lead } from '../../model/leads.model';
import { Enum } from '../../model/enum.model';
import GenericBoard from '../Generic/GenericBoard';
import GenericTab from '../Generic/GenericTab';
import './leads.css';
import { addLead2 } from '../../Redux/Leads/leadsAction';
import AddLeadForm from './addLead.component';
import LeadInfoView from './leadsInfo';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ChatTable from '../../Component/tasks/chat'; // או הנתיב הנכון לקובץ שלך
import { FaTrash } from 'react-icons/fa';
import { setRef } from '@mui/material';


const Leads: React.FC = () => {
  const dispatch = useDispatch();
  const [view, setView] = useState<'board' | 'list'>('board');
  const [selectedLeadId, setSelectedLeadId] = useState<number | null>(null);
  const leadsArr = useSelector((state: { leads: { allLeads: Lead[] } }) => state.leads.allLeads);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [statusOptions, setStatusOptions] = useState<Enum[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const MySwal = withReactContent(Swal);
  const [showSearch, setShowSearch] = useState(false);
  const [loading, setLoading] = useState(true);
const [selectedLead, setSelectedLead] = useState<Lead | null>(null);

    //  selectedLead = leads.find(l => Number(l.id) === selectedLeadId) || null;
const fetchData = async () => {
      try {
        const leadsRes = await getAllLeads();
console.log('DATA FROM API:', leadsRes.data);
console.log('סטטוסים קיימים:', leads.map(l => l.status));
console.log('lead example:', leads[0])

        const statusRes = await getAllEnumFromServer(1);

        const leadsWithFullName = leadsRes.data.map((lead: Lead) => ({
          ...lead,
          fullName: `${lead.firstName ?? ''} ${lead.lastName ?? ''}`.trim()
        }));
        setLeads(leadsWithFullName);
console.log('Leads after adding fullName:', leadsWithFullName);

        setStatusOptions(statusRes);
      } finally {
        setLoading(false); 
      }
    };
  useEffect(() => {
    
    fetchData();
  }, [dispatch]);
useEffect(() =>{
console.log(selectedLead)
},[selectedLead])
  const handleAddLead = () => {
    Swal.fire({
      title: 'הוספת ליד חדש',
      html: '<div id="add-lead-container"></div>',
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      didOpen: () => {
        const container = document.getElementById('add-lead-container');
        if (container) {
          const root = createRoot(container);
          root.render(
            <AddLeadForm
              leads={leads}
              setLeads={setLeads}
              handleLeadAdded={async (newLead: Lead) => {
                try {
                  const response = await addLead(newLead);
                  const addedLead = response.data;

                  addedLead.createdDate = new Date(addedLead.createdDate);
                  addedLead.lastContacted = new Date(addedLead.lastContacted);
                  addedLead.fullName = `${addedLead.firstName ?? ''} ${addedLead.lastName ?? ''}`.trim();

                  setLeads([addedLead, ...leads]);
                  dispatch(addLead2(addedLead));

                  Swal.close();
                  Swal.fire({
                    title: 'Success',
                    text: 'הליד נוסף בהצלחה',
                    icon: 'success',
                    confirmButtonText: 'אישור',
                    customClass: {
                      confirmButton: 'my-confirm-button',
                    },
                  });
                } catch (error) {
                  Swal.fire('Error', 'שגיאה בהוספת הליד', 'error');
                }
              }}
            />
          );
        }
      },
    });
  };
const openLeadPopup = (id: string) => {
   const lead = leads.find(l => l.id === id);
  if (lead) {
    setSelectedLead(lead);
    setModalOpen(true);
  }

};
const handleCloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
            }
             setModalOpen(false);
          };    

  const config = {
    categoryField: 'status',
    categories: [
      { label: 'ליד חדש', color: '#2c6d8f' },
      { label: 'שיחת מעקב', color: '#2c6d8f' },
      { label: 'העברה להקמה בפועל', color: '#2c6d8f' },
      { label: 'פגישת אפיון', color: '#2c6d8f' },
      { label: 'נשלחה הצעת מחיר', color: '#2c6d8f' },
      { label: 'שליחת הצעת מחיר', color: '#2c6d8f' },
      { label: 'הוצאת חשבונית בפועל', color: '#2c6d8f' },
      { label: 'שיחה ראשונית', color: '#2c6d8f' },
      { label: 'נשלחה הצעת מחיר', color: '#2c6d8f' },
      { label: 'שיחת מעקב', color: '#2c6d8f' },
      { label: 'שליחת הצעת מחיר', color: '#2c6d8f' },
      { label: 'העברה להקמה בפועל', color: '#2c6d8f' },
    ],
    displayFields: [
      { key: 'fullName', label: 'שם' },
      { key: 'email', label: 'אימייל' },
      { key: 'phone', label: 'טלפון' },
    ],
    actionLabel: 'פרטים',
    idField:"id"
  };

  const configTab = {
    ...config,
    displayFields: [
      ...config.displayFields,
      { key: 'status', label: 'סטטוס' },
      { key: 'source', label: 'מקור הליד' },
    ],
  };

  const filteredLeads = leads.filter((lead) => {
    const combinedValues = [
      lead.firstName,
      lead.lastName,
      lead.email,
      lead.phone,
      lead.businessName,
      lead.source,
      lead.freeText,
    ]
      .join(' ')
      .toLowerCase();
     

    return combinedValues.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="lead-board-container">
      <div className="tabs-container">
        <div className={`tab ${view === 'board' ? 'active' : ''}`} onClick={() => setView('board')}>
          לוח
        </div>
        <div className={`tab ${view === 'list' ? 'active' : ''}`} onClick={() => setView('list')}>
          רשימה
        </div>
      </div>

      <div className="header-wrapper">
        <div className="header-content">
          <div className="left-section">
            <button
              className="search-toggle"
              onClick={() => setShowSearch(!showSearch)}
              title="חיפוש"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 24 24" width="50" fill="#2c3e50">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
              </svg>
            </button>

            {showSearch && (
              <input
                type="text"
                placeholder="חיפוש..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-line-inline"
                autoFocus
              />
            )}
          </div>

          <h1 className="lead-title">לידים</h1>

          <button className="add-lead-button" onClick={handleAddLead}>
            +
            <span className="add">להוספת ליד</span>
          </button>
                    {/* <button
                      className="delete-lead-button"
                      onClick={() => handleDeleteLead(lead.id)}
                      title="מחק ליד"
                    >
                      <FaTrash style={{ fontSize: '16px', color: '#e74c3c' }} />
                    </button> */}




        </div>

      </div>

      
      {loading ? (
        <div className="loading-message">טוען לידים...</div>
      ) : leads.length === 0 ? (
        <div className="no-results">לא נמצאו לידים</div>
      ) : (
        <div className="newClassLead" >
          <div className='innerdiv'>
            {view === 'board' ? (
              <GenericBoard data={filteredLeads} config={config}  openItemPopup={openLeadPopup}lookups={{}} />
            ) : (
              <GenericTab data={filteredLeads} config={configTab} openItemPopup={openLeadPopup}  lookups={{}} />
            )}
          </div>
         {modalOpen && selectedLead && (
                   <Modal open={modalOpen} onClose={handleCloseModal}>
            <Box
              sx={{
                backgroundColor: '#fff',
                display: "flex",
                flexDirection: 'row',
                padding: '20px',
                borderRadius: '10px',
                border: '1px solid #ccc',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                width: '80%',
                height: "80%",
                top: "50%",
                left: "50%",
                position: 'absolute',
                direction: 'rtl',
                transform: 'translate(-50%, -50%)'
              }}
            >
             <LeadInfoView  onClose={() => setModalOpen(false)} refresh={fetchData} selectedLead={selectedLead} />
              <ChatTable itemId={selectedLead.id} />
            </Box>
          </Modal>
        )}
        </div>
      )}
    </div>
  );
};

export default Leads;
